import { palette, admin, statusDot as sd, roleColor } from '../../styles/tokens';
import type { CrewMember } from '../../types';

function getCrewColor(member: CrewMember): string {
  if (member.employmentType === 'contractor') return palette.amber;
  if (member.employmentType === 'operator') return palette.blue;
  return roleColor[member.role as keyof typeof roleColor] ?? palette.g300;
}

function getStatusDotColor(status: string): string {
  if (status === 'working') return sd.active;
  if (status === 'late' || status === 'scheduled') return sd.idle;
  return sd.off;
}

function getStatusLabel(status: string): { label: string; color: string; bg: string } {
  if (status === 'working') return { label: 'On site', color: '#059669', bg: '#ECFDF3' };
  if (status === 'late') return { label: 'Late', color: '#DC2626', bg: '#FEF2F2' };
  if (status === 'scheduled') return { label: 'Upcoming', color: '#0F6CBD', bg: '#EFF6FF' };
  return { label: 'Day off', color: '#8E8E93', bg: '#F3F4F6' };
}

function CrewRow({ member }: { member: CrewMember }) {
  const color = getCrewColor(member);
  const dotColor = getStatusDotColor(member.status);
  const badge = getStatusLabel(member.status);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      padding: '10px 0',
      borderBottom: `0.5px solid ${admin.border}`,
    }}>
      <div style={{ position: 'relative' }}>
        <div style={{
          width: 34, height: 34, borderRadius: 17,
          background: color,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 11, fontWeight: 600, color: palette.white, flexShrink: 0,
        }}>{member.initials}</div>
        <div style={{
          position: 'absolute', bottom: -1, right: -1,
          width: sd.size, height: sd.size, borderRadius: sd.size / 2,
          background: dotColor, border: `${sd.borderWidth}px solid ${palette.white}`,
        }} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, fontWeight: 500, color: admin.header }}>{member.name}</div>
        <div style={{ fontSize: 11, color: admin.caption, marginTop: 1 }}>{member.shiftTime}</div>
      </div>
      <div style={{
        fontSize: 10, fontWeight: 500, color: badge.color, background: badge.bg,
        padding: '2px 8px', borderRadius: 6,
      }}>{badge.label}</div>
    </div>
  );
}

interface CrewTodayProps {
  crew: CrewMember[];
}

export function CrewToday({ crew }: CrewTodayProps) {
  if (crew.length === 0) {
    return (
      <div style={{ padding: '20px 0', textAlign: 'center', color: admin.caption, fontSize: 13 }}>
        No crew members scheduled today.
      </div>
    );
  }

  return (
    <div>
      {crew.map(member => (
        <CrewRow key={member.id} member={member} />
      ))}
    </div>
  );
}
